/** Custom header component for datepicker. */ import { ChangeDetectionStrategy,
  ChangeDetectorRef, Component, Inject, OnDestroy } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import moment from 'moment';
// @ts-ignore – moment locale side-effect import has no type declarations in TS6
import 'moment/locale/de';
@Component({
    selector: 'bdo-datepicker-custom-header',
    templateUrl: 'custom-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomHeaderComponent<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
    private _calendar: MatCalendar<D>,
    private _dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
    cdr: ChangeDetectorRef,
  ) {
    moment.locale('de');
    _calendar.stateChanges.pipe(takeUntil(this._destroyed)).subscribe({ next: () => cdr.markForCheck() });
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  get periodLabel() {
    return moment(this._calendar.activeDate).format('MMMM YYYY');
  }

  get selectedYear() {
    return this._dateAdapter
      .getYear(this._calendar.activeDate);
  }

  get dateLabel() {
    return moment(this._calendar.activeDate).format('dd, DD. MMMM');
  }

  previousClicked(mode: 'month' | 'year') {
    this._calendar.activeDate =
      mode === 'month'
        ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1)
        : this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }

  nextClicked(mode: 'month' | 'year') {
    this._calendar.activeDate =
      mode === 'month'
        ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1)
        : this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }
}
